"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getGoogleIntegrationCredentials;

var _enviro = _interopRequireDefault(require("enviro"));

var GoogleIntegrationCredentials = Object.freeze({
  prod: {
    developerKey: 'AIzaSyAA5yZ_l-hwabx5DlFEOp5oqG0s2nneb5o',
    clientId: '582723723500-tuagdojeeamkupespskvbce82g1c7tq4.apps.googleusercontent.com'
  },
  qa: {
    developerKey: 'AIzaSyALoW-ASn6J1eRgrSnesHXlLcsGzmxfBrI',
    clientId: '865670317198-giofriqoud2sbkf9lkapusrb6kd4tf43.apps.googleusercontent.com'
  }
});

function getGoogleIntegrationCredentials() {
  return GoogleIntegrationCredentials[_enviro.default.getShort()];
}

module.exports = exports.default;